import { Controller } from "@hotwired/stimulus"

// Clipboard controller for copying text to clipboard
export default class extends Controller {
  static targets = ["source", "button"]
  static values = { successClass: { type: String, default: "border-green-500" } }

  async copy() {
    const text = this.sourceTarget.value || this.sourceTarget.textContent

    try {
      await navigator.clipboard.writeText(text)
      this.showSuccess()
    } catch (err) {
      // Fallback for older browsers
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text) {
    const textArea = document.createElement("textarea")
    textArea.value = text
    textArea.style.position = "fixed"
    textArea.style.left = "-999999px"
    document.body.appendChild(textArea)
    textArea.select()

    try {
      document.execCommand("copy")
      this.showSuccess()
    } catch (err) {
      console.error("Failed to copy text:", err)
    }

    document.body.removeChild(textArea)
  }

  showSuccess() {
    // Add success styling to button
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.add(this.successClassValue)
      this.buttonTarget.setAttribute("data-copied", "true")

      setTimeout(() => {
        this.buttonTarget.classList.remove(this.successClassValue)
        this.buttonTarget.removeAttribute("data-copied")
      }, 2000)
    }
  }
}
